/*
 * @Author: wsx
 * @Date: 2022-01-19 09:28:58
 * @LastEditTime: 2022-01-19 17:49:18
 * @LastEditors: your name
 * @Description: 重点车辆
 */
import request from "@/utils/request.js";

// 获取车辆人员库列表
export const libraryList = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/library/list",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};
// 获取频繁出没列表
export const frequencyAppearKey = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/car_search_detail/haunt/common/count",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};

// 获取频繁出没详情
export const frequencyAppearDetail = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/car_search_detail/haunt/common/detail",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};

// 获取频繁出没chart
export const frequencyAppearChart = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/car_search_detail/haunt/common/chart",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};

// 获取昼伏夜出列表
export const crouchKey = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/car_search_detail/crouch/common/count",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};

// 获取昼伏夜出详情
export const crouchDetail = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/car_search_detail/crouch/common/detail",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};

// 获取昼伏夜出chart
export const crouchChart = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/car_search_detail/crouch/common/chart",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};

// 获取首次出现chart
export const firstAppear = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/car_search_detail/first-appear/detail",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};

/*
 * @Author: wsx
 * @Date: 2022-01-19 09:28:58
 * @LastEditTime: 2022-01-19 17:49:18
 * @LastEditors: your name
 * @Description: 重点人员
 */


// 获取频繁出没列表
export const faceFrequencyAppearKey = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/face_search_detail/haunt/common/count",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};

// 获取频繁出没详情
export const facefrequencyAppearDetail = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/face_search_detail/haunt/common/detail",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};

// 获取频繁出没chart
export const facefrequencyAppearChart = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/face_search_detail/haunt/common/chart",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};

// 获取昼伏夜出列表
export const facecrouchKey = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/face_search_detail/crouch/common/count",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};

// 获取昼伏夜出详情
export const facecrouchDetail = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/face_search_detail/crouch/common/detail",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};

// 获取昼伏夜出chart
export const facecrouchChart = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/face_search_detail/crouch/common/chart",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};

// 获取首次出现
export const facefirstAppear = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/face_search_detail/first-appear/detail",
    data: data || {},
    method: "post",
    ...loadingObj
  });
};